import {setURLParams} from 'BenchlingUtil';
import {StructuredTableDict} from 'notebook/documents/DocumentConstants';
import * as net from 'util/Net';

import {StructuredTableKind} from './StructuredTableConstants';

export interface EntryTablesResponse {
  tables: Array<StructuredTableDict>;
}

export interface GetEntryTablesParams {
  entryApiId: string;
  tableKind?: StructuredTableKind;
  schemaId?: string;
  omitRowAndColumnData?: boolean;
}

export async function getEntryTables(params: GetEntryTablesParams): Promise<EntryTablesResponse> {
  const url = getEntryTableUrl(params);
  const response: EntryTablesResponse = await net.getJSONPromise(url);
  return response;
}

export function getEntryTableUrl(params: GetEntryTablesParams): string {
  return setURLParams(`/1/api/entries/${params.entryApiId}/structured-tables`, {
    table_kind: params.tableKind,
    schema_id: params.schemaId,
    omit_row_and_column_data: params.omitRowAndColumnData,
  });
}
